(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskFilterReplace',
	};

	var form_id = 'taskfilterreplace-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var filter_id         = $('#' + form_id + 'task_filter_id').val();
		var $filter_container = $('.task-filter-' + filter_id);
		var picker_color      = $filter_container.find('#' + form_id + 'existing_color').first().val();

		// cancel link
		$filter_container.find('.cancel-replace-btn').first().on('click', function onCancelClick(e)
		{
			e.preventDefault();

			$filter_container.find('.task-filter-tasks').removeClass('hidden');

			// set container back to default state
			$filter_container.find('.task-filter-replace').addClass('hidden').html('Loading replace task filter panel form...');
		});

		// init color picker
		$filter_container.find('#colorpicker').first().spectrum({
			color      : picker_color,
			showInitial: true,
			showInput  : true,
			change     : function changeColor(color) {
				var new_color = color.toHexString().toUpperCase();
				$filter_container.find('#' + form_id + 'filter_color').first().val(new_color);
			}
		});
	};
}(jQuery, window.Adzuki || {}));
